module.exports = __webpack_public_path__ + "img/whitelist-blank-state.e950c458.svg";